import { ChevronRight } from "lucide-react";

import { PageHeader } from "@/components/shared/page-header";
import { RuledList, RuledListItem } from "@/components/shared/ruled-list";
import { useAuth } from "@/providers/auth.provider";

const SETTINGS_LINKS = [
  { to: "/dashboard/settings/user-profile", title: "Profile", description: "Your name and avatar" },
  { to: "/dashboard/settings/change-password", title: "Change password", description: "Update the one you sign in with" },
] as const;

const SettingsPage = () => {
  const { logout, user } = useAuth();
  return (
    <div className="flex flex-col gap-5">
      <PageHeader title="Settings" description={user?.email} />
      <nav aria-label="Settings">
        <RuledList>
          {SETTINGS_LINKS.map((item) => (
            <RuledListItem key={item.to} to={item.to}>
              <span className="flex flex-col">
                <span className="font-semibold">{item.title}</span>
                <span className="text-[12.5px] text-muted-foreground">{item.description}</span>
              </span>
              <ChevronRight className="size-4 shrink-0 text-muted-foreground" aria-hidden />
            </RuledListItem>
          ))}
          <RuledListItem>
            <button type="button" onClick={() => logout()} className="flex w-full flex-col text-left">
              <span className="font-semibold text-brand">Sign out</span>
              <span className="text-[12.5px] text-muted-foreground">Ends this session on this device</span>
            </button>
          </RuledListItem>
        </RuledList>
      </nav>
    </div>
  );
};

export default SettingsPage;
